import React from "react";
import { getCurrentEnv, setDashboardEnv } from "../services/api";

const EnvToggle = () => {
  const currentEnv = getCurrentEnv();
  const isProd = currentEnv === "production";

  const handleToggle = () => {
    const confirmed = window.confirm(
      `Switch to ${isProd ? "DEVELOPMENT" : "PRODUCTION"}? You will need to log in again.`
    );
    if (confirmed) {
      setDashboardEnv(isProd ? "development" : "production");
    }
  };

  return (
    <button onClick={handleToggle} style={styles.button(isProd)}>
      {isProd ? "🟢 PRODUCTION" : "🟠 DEVELOPMENT"}
    </button>
  );
};

const styles = {
  button: (isProd) => ({
    padding: "8px 16px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "700",
    fontSize: "13px",
    color: "#fff",
    cursor: "pointer",
    backgroundColor: isProd ? "#16A34A" : "#EA580C",
  }),
};

export default EnvToggle;